var cov_7a8b7heya = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/expose.ts",
      hash = "0d69fccec6200c5fecd8117270a1c90340f0f673",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/expose.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 14
        },
        end: {
          line: 8,
          column: 70
        }
      },
      "1": {
        start: {
          line: 9,
          column: 14
        },
        end: {
          line: 9,
          column: 47
        }
      },
      "2": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 89
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 16
        }
      },
      "5": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "6": {
        start: {
          line: 25,
          column: 36
        },
        end: {
          line: 25,
          column: 59
        }
      },
      "7": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 98
        }
      },
      "8": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 16
        }
      },
      "9": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "10": {
        start: {
          line: 30,
          column: 38
        },
        end: {
          line: 30,
          column: 61
        }
      },
      "11": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 93
        }
      },
      "12": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 16
        }
      },
      "13": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 13
        }
      },
      "14": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "15": {
        start: {
          line: 38,
          column: 29
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "16": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 41,
          column: 14
        }
      },
      "17": {
        start: {
          line: 40,
          column: 38
        },
        end: {
          line: 40,
          column: 74
        }
      },
      "18": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 54,
          column: 4
        }
      },
      "19": {
        start: {
          line: 46,
          column: 23
        },
        end: {
          line: 46,
          column: 49
        }
      },
      "20": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 75
        }
      },
      "21": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "22": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 28
        }
      },
      "23": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 18
        }
      },
      "24": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 26
        }
      },
      "25": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 26
        }
      },
      "26": {
        start: {
          line: 66,
          column: 48
        },
        end: {
          line: 66,
          column: 94
        }
      },
      "27": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 43
        }
      },
      "28": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 17
        }
      },
      "29": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 77,
          column: 3
        }
      },
      "30": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 16
        }
      },
      "31": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "32": {
        start: {
          line: 73,
          column: 25
        },
        end: {
          line: 73,
          column: 48
        }
      },
      "33": {
        start: {
          line: 74,
          column: 29
        },
        end: {
          line: 74,
          column: 65
        }
      },
      "34": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 66
        }
      },
      "35": {
        start: {
          line: 75,
          column: 40
        },
        end: {
          line: 75,
          column: 66
        }
      },
      "36": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "37": {
        start: {
          line: 79,
          column: 15
        },
        end: {
          line: 79,
          column: 32
        }
      },
      "38": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "39": {
        start: {
          line: 81,
          column: 21
        },
        end: {
          line: 81,
          column: 48
        }
      },
      "40": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 33
        }
      },
      "41": {
        start: {
          line: 82,
          column: 18
        },
        end: {
          line: 82,
          column: 33
        }
      },
      "42": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 85,
          column: 17
        }
      },
      "43": {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "44": {
        start: {
          line: 96,
          column: 18
        },
        end: {
          line: 96,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "validateFormat",
        decl: {
          start: {
            line: 19,
            column: 9
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 38
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 32
          }
        },
        loc: {
          start: {
            line: 25,
            column: 36
          },
          end: {
            line: 25,
            column: 59
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 33
          },
          end: {
            line: 30,
            column: 34
          }
        },
        loc: {
          start: {
            line: 30,
            column: 38
          },
          end: {
            line: 30,
            column: 61
          }
        },
        line: 30
      },
      "3": {
        name: "getClassname",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 21
          }
        },
        loc: {
          start: {
            line: 37,
            column: 41
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 40,
            column: 9
          },
          end: {
            line: 40,
            column: 10
          }
        },
        loc: {
          start: {
            line: 40,
            column: 38
          },
          end: {
            line: 40,
            column: 74
          }
        },
        line: 40
      },
      "5": {
        name: "resetTheme",
        decl: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 19
          }
        },
        loc: {
          start: {
            line: 44,
            column: 22
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 44
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 45,
            column: 36
          },
          end: {
            line: 45,
            column: 37
          }
        },
        loc: {
          start: {
            line: 45,
            column: 65
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 45
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 49,
            column: 47
          },
          end: {
            line: 49,
            column: 48
          }
        },
        loc: {
          start: {
            line: 49,
            column: 86
          },
          end: {
            line: 52,
            column: 7
          }
        },
        line: 49
      },
      "8": {
        name: "getInjectType",
        decl: {
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 58,
            column: 22
          }
        },
        loc: {
          start: {
            line: 58,
            column: 25
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 58
      },
      "9": {
        name: "setInjectType",
        decl: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 61,
            column: 22
          }
        },
        loc: {
          start: {
            line: 61,
            column: 56
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 61
      },
      "10": {
        name: "setStyle",
        decl: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 17
          }
        },
        loc: {
          start: {
            line: 65,
            column: 113
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 65
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 80,
            column: 11
          },
          end: {
            line: 80,
            column: 12
          }
        },
        loc: {
          start: {
            line: 80,
            column: 17
          },
          end: {
            line: 83,
            column: 5
          }
        },
        line: 80
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 85,
            column: 9
          },
          end: {
            line: 85,
            column: 10
          }
        },
        loc: {
          start: {
            line: 85,
            column: 15
          },
          end: {
            line: 85,
            column: 17
          }
        },
        line: 85
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }, {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }],
        line: 30
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 38
          }
        }, {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 38
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 62
          },
          end: {
            line: 65,
            column: 111
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 93
          },
          end: {
            line: 65,
            column: 111
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 66,
            column: 48
          },
          end: {
            line: 66,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 48
          },
          end: {
            line: 66,
            column: 65
          }
        }, {
          start: {
            line: 66,
            column: 69
          },
          end: {
            line: 66,
            column: 84
          }
        }, {
          start: {
            line: 66,
            column: 88
          },
          end: {
            line: 66,
            column: 94
          }
        }],
        line: 66
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        }, {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 66
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 66
          }
        }],
        line: 75
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 16
          }
        }, {
          start: {
            line: 75,
            column: 20
          },
          end: {
            line: 75,
            column: 38
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }],
        line: 78
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 33
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 33
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { isObject } from './is';
import { exposeClass } from '../styles/expose';
import cssAccessors, { cleanCache } from './css-accessors';
import { capitalize } from './strings';
import { entries } from './objects';
import { injectTag, cleanStyleObj, setThemeConfig } from './vars-inject';
var types = (cov_7a8b7heya.s[0]++, ['primary', 'warning', 'danger', 'success', 'secondary']);
var attrs = (cov_7a8b7heya.s[1]++, ['background', 'color', 'border']);

function validateFormat(data) {
  cov_7a8b7heya.f[0]++;
  cov_7a8b7heya.s[2]++;

  if (!isObject(data)) {
    cov_7a8b7heya.b[0][0]++;
    cov_7a8b7heya.s[3]++;
    console.error(new Error('Should enter a json data with attrs(key) and types(types)'));
    cov_7a8b7heya.s[4]++;
    return false;
  } else {
    cov_7a8b7heya.b[0][1]++;
  } // attributes


  cov_7a8b7heya.s[5]++;

  if (Object.keys(data).filter(function (v) {
    cov_7a8b7heya.f[1]++;
    cov_7a8b7heya.s[6]++;
    return attrs.indexOf(v) === -1;
  }).length > 0) {
    cov_7a8b7heya.b[1][0]++;
    cov_7a8b7heya.s[7]++;
    console.error(new Error("The attribute your entered does not exist need[".concat(attrs.join('/'), "]")));
    cov_7a8b7heya.s[8]++;
    return false;
  } else {
    cov_7a8b7heya.b[1][1]++;
  } // types


  cov_7a8b7heya.s[9]++;

  if (Object.values(data).filter(function (v) {
    cov_7a8b7heya.f[2]++;
    cov_7a8b7heya.s[10]++;
    return types.indexOf(v) === -1;
  }).length > 0) {
    cov_7a8b7heya.b[2][0]++;
    cov_7a8b7heya.s[11]++;
    console.error(new Error("The type your entered does not exist need[".concat(types.join('/'), "]")));
    cov_7a8b7heya.s[12]++;
    return false;
  } else {
    cov_7a8b7heya.b[2][1]++;
  }

  cov_7a8b7heya.s[13]++;
  return true;
}

function getClassname(data) {
  cov_7a8b7heya.f[3]++;
  cov_7a8b7heya.s[14]++;

  if (!validateFormat(data)) {
    cov_7a8b7heya.b[3][0]++;
    cov_7a8b7heya.s[15]++;
    return '';
  } else {
    cov_7a8b7heya.b[3][1]++;
  }

  cov_7a8b7heya.s[16]++;
  return Object.keys(data).map(function (attr) {
    cov_7a8b7heya.f[4]++;
    cov_7a8b7heya.s[17]++;
    return exposeClass("".concat(data[attr], "-").concat(attr));
  }).join(' ');
}

function resetTheme() {
  cov_7a8b7heya.f[5]++;
  cov_7a8b7heya.s[18]++;
  Object.keys(cssAccessors).forEach(function (module) {
    cov_7a8b7heya.f[6]++;
    var setterName = (cov_7a8b7heya.s[19]++, "set".concat(capitalize(module)));
    var setter = (cov_7a8b7heya.s[20]++, cssAccessors[module][setterName]);
    cov_7a8b7heya.s[21]++;
    setter(Object.keys(cssAccessors[module]).reduce(function (obj, key) {
      cov_7a8b7heya.f[7]++;
      cov_7a8b7heya.s[22]++;
      obj[key] = undefined;
      cov_7a8b7heya.s[23]++;
      return obj;
    }, {}));
  });
}

var defaultInjectType;

function getInjectType() {
  cov_7a8b7heya.f[8]++;
  cov_7a8b7heya.s[24]++;
  return defaultInjectType;
}

function setInjectType(type) {
  cov_7a8b7heya.f[9]++;
  cov_7a8b7heya.s[25]++;
  defaultInjectType = type;
}

function setStyle(options, custom) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_7a8b7heya.b[4][0]++, {
    target: 'body'
  });
  cov_7a8b7heya.f[10]++;
  var injectType = (cov_7a8b7heya.s[26]++, (cov_7a8b7heya.b[5][0]++, config.injectType) || (cov_7a8b7heya.b[5][1]++, getInjectType()) || (cov_7a8b7heya.b[5][2]++, 'body'));
  cov_7a8b7heya.s[27]++;
  setThemeConfig(_objectSpread2(_objectSpread2({}, config), {}, {
    injectType: injectType
  }));
  cov_7a8b7heya.s[28]++;
  cleanStyleObj();
  cov_7a8b7heya.s[29]++;

  if (!options) {
    cov_7a8b7heya.b[6][0]++;
    cov_7a8b7heya.s[30]++;
    resetTheme();
  } else {
    cov_7a8b7heya.b[6][1]++;
    cov_7a8b7heya.s[31]++;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = entries(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            values = _step$value[1];

        var setterName = (cov_7a8b7heya.s[32]++, "set".concat(capitalize(key)));
        var module = (cov_7a8b7heya.s[33]++, cssAccessors[key]);
        cov_7a8b7heya.s[34]++;

        if ((cov_7a8b7heya.b[8][0]++, module) && (cov_7a8b7heya.b[8][1]++, module[setterName])) {
          cov_7a8b7heya.b[7][0]++;
          cov_7a8b7heya.s[35]++;
          module[setterName](values);
        } else {
          cov_7a8b7heya.b[7][1]++;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  cov_7a8b7heya.s[36]++;

  if (injectType === 'tag') {
    cov_7a8b7heya.b[9][0]++;
    var id = (cov_7a8b7heya.s[37]++, injectTag(custom));
    cov_7a8b7heya.s[38]++;
    return function () {
      cov_7a8b7heya.f[11]++;
      var target = (cov_7a8b7heya.s[39]++, document.getElementById(id));
      cov_7a8b7heya.s[40]++;

      if (target) {
        cov_7a8b7heya.b[10][0]++;
        cov_7a8b7heya.s[41]++;
        target.remove();
      } else {
        cov_7a8b7heya.b[10][1]++;
      }
    };
  } else {
    cov_7a8b7heya.b[9][1]++;
  }

  cov_7a8b7heya.s[42]++;
  return function () {
    cov_7a8b7heya.f[12]++;
  };
}

var style = (cov_7a8b7heya.s[43]++, {
  getClassname: getClassname,
  setStyle: setStyle,
  cleanCache: cleanCache,
  setInjectType: setInjectType,
  getInjectType: getInjectType
});

var _ref = (cov_7a8b7heya.s[44]++, cssAccessors),
    color = _ref.color;

export { color, style, types };